var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6899 12.2096H5.42422L14.8319 2.80151C15.3358 2.29802 15.3358 1.48098 14.8319 0.977526C14.3284 0.473637 13.5114 0.473637 13.0079 0.977526L0.485596 13.4995L13.0079 26.0214C13.2593 26.2734 13.5896 26.3994 13.9198 26.3994C14.25 26.3994 14.5804 26.2734 14.8319 26.0214C15.3358 25.5179 15.3358 24.7009 14.8319 24.1975L5.42422 14.7894H30.6899C31.4024 14.7894 31.9799 14.2119 31.9799 13.4994C31.9799 12.7869 31.4024 12.2094 30.6899 12.2094V12.2096Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back_arrow.594f9ab6b3cec8b294613689a9aaff4c.svg";
export { ForwardRef as ReactComponent };